module.exports = __webpack_public_path__ + "img/5-5.4a0ce37a.svg";